import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { translate } from '../../../../../utils/Common';
import Spinner from '../../../../../components/Spinner';
import { usePlatforms } from '../../../../../hooks/usePlatforms';
import PlatformSearchList from '../../../../../components/PlatformSearchList';
import * as FaIcons from 'react-icons/fa';
import * as MdIcons from 'react-icons/md';
import ModalContent from '../../../../../components/ModalContent';
import ignoreAbort from '../../../../../utils/ignoreAbort';

const FormGenerate = (props) => {
    const { getPlatformDetails } = usePlatforms();
    const { register, handleSubmit, errors, clearErrors, reset, setValue } = useForm();
    const [loading, setLoading] = useState(false);
    const [platformSelect, setPlatformSelect] = useState(null);
    const [platformDetails, setPlatformDetails] = useState(null);
    const [loadingPlatformDetails, setLoadingPlatformDetails] = useState(false); // Estado para la animación de carga
    const [modalTitle, setModalTitle] = useState('');
    const [body, setBody] = useState(null);
    const [footer, setFooter] = useState(null);
    const [isOpenModal, setIsOpenModal] = useState(false);

    const handleResetForm = () => {
        clearErrors();
        reset();
        setPlatformSelect(null); // Limpia la selección de la plataforma
        setPlatformDetails(null); // Limpia los detalles de la plataforma
    }


    useEffect(() => {
        const abortController = new AbortController();
        const handlePlatform = async () => {
            if (platformSelect) {
                setLoadingPlatformDetails(true); // Inicia la animación de carga
                
                const response = await getPlatformDetails(
                    platformSelect.boxitLocationId,
                    abortController.signal
                );
                setPlatformDetails(response);
                setLoadingPlatformDetails(false); // Termina la animación de carga
            }
        };
        handlePlatform().catch(ignoreAbort);
        return () => abortController.abort();
    }, [platformSelect]);

    const onSubmit = async (data) => {
        try {
            setLoading(true);
            let cepLocker = platformDetails?.Address  || "" ; 
            if (cepLocker === "") {
                setIsOpenModal(true);
                setModalTitle(translate('global.alert.attention'));
                setBody(translate('dashboard.platforms.generateQR.formGenerate.errorAddress'));
                setFooter(
                    <button
                        type="button"
                        className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90"
                        onClick={() => setIsOpenModal(false)}
                    >
                        {translate('global.accept')}
                    </button>
                );
                setLoading(false);
                return;
            }

            await props.onGenerateQR({
                ...data,
                cepLocker,
            });
         
            setLoading(false);
        } catch (error) {
            console.error(error);
            // Abrir modal para mostrar errores
            setIsOpenModal(true);
            setModalTitle(translate("global.alert.attention"));
            setBody(translate("global.alerts.requestError"));
            setFooter(
                <button
                    type="button"
                    className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90"
                    onClick={() => setIsOpenModal(false)}
                >
                    {translate("global.accept")}
                </button>
            );
        } 
    };
    
    return (
        <>
          <div className="form-container">
               <form className="form-container" onSubmit={handleSubmit(onSubmit)} >
             
             {!platformSelect && (
               <>
              <div className="dashboardCard tracking-busqueda text-left">
               <div className="flex flex-wrap -mx-2 text-left mt-0 mb-2">
                    <span className="text-sm">
                        {translate("global.selectPlatform")}
                    </span>
                </div>
                <div className="flex flex-wrap -mx-2">
                    
                        <div className="mb-3 text-left w-full md:w-4/12 mb-2">
                            <PlatformSearchList
                                register={register}
                                errors={errors}
                                setPlatformSelect={setPlatformSelect}
                                platfSelect={platformSelect}
                                valueId={"plataforma"}
                                readOnly={false}
                                setValue={setValue}
                            />
                        </div>
              
                </div>
                </div>
                    </> 
                )}
             
            
              {loadingPlatformDetails ? (
                    <div className="flex flex-wrap -mx-2 mb-0 p-0">
                        <div className="mb-3 w-full text-center m-2">
                            <Spinner type={1} />
                        </div>
                    </div>
                ) : ( 

                    platformDetails && (
                        <>
                    <div className='dashboardCard tracking-busqueda text-left'>
                        <div className="flex flex-wrap -mx-2 mx-0 mb-1 border-bottom titleTransaccion"> 
                            <h5 className="ml-2 my-1">{translate("global.infoPlatform")}</h5>
                            </div>
                        <div className="flex flex-wrap -mx-2">
                            <div className="mb-3 w-full platform-details text-left">
                                 
                                 <div className="flex flex-wrap -mx-2 mx-0">
                                        <div className="w-full pb-0 mb-0">
                                            <p><strong>{translate("global.name")}: </strong> {platformDetails?.Nombre ? platformDetails.Nombre : " "}</p>
                                        </div>
                                  </div>

                                    <div className="flex flex-wrap -mx-2 mx-0">
                                        <div className="w-full pb-0 mb-0">
                                            <p><strong>{translate("global.ubication")}: </strong> {platformDetails?.Direccion_Fisica ? platformDetails.Direccion_Fisica : ""}</p>
                                        </div>
                                    </div>

                                <div className="flex flex-wrap -mx-2 mx-0">
                                    <div className="w-7/12 pb-0 mb-0">
                                        <p><strong>{translate("global.platformID")}: </strong> {platformDetails?.IdPlataforma ? platformDetails.IdPlataforma : ""}</p>
                                    </div>
                                </div>

                                <div className="flex flex-wrap -mx-2 mx-0">
                                    <div className="w-7/12 pb-0 mb-0">
                                        <p><strong>{translate("global.ExternalID")}: </strong> {platformSelect?.locationId ? platformSelect.locationId : ""}</p>
                                    </div>
                                </div>

                                <div className="flex flex-wrap -mx-2 mx-0">
                                    <div className="w-7/12 pb-0 mb-0">
                                        <p><strong>CEP: </strong> {platformDetails?.Address ? platformDetails.Address : ""}</p>
                                    </div>
                                </div>
                                    {/* Muestra más detalles según sea necesario */}
                              </div>
                            </div>
                            <div className="flex flex-wrap -mx-2 text-left mt-0 mb-2">
                                <span className="text-sm">
                                    {translate("dashboard.platforms.generateQR.formGenerate.description")}
                                </span>
                            </div>
                            <div className="flex flex-wrap -mx-2">
                                <div className="mb-3 text-left w-full md:w-6/12 mb-2">
                                    <div className="flex w-full items-stretch">
                                        <div className="flex items-center">
                                            <span className="flex items-center px-3 text-muted-foreground" id="matricula">
                                                <FaIcons.FaUser size={14} />
                                            </span>
                                        </div>
                                        <input
                                            type="text"
                                            className={"h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed h-9 text-sm text-sm" + (errors.numeroPaquete ? " border-destructive" : "")}
                                            placeholder={translate("global.matricula")}
                                            id="matricula"
                                            name="matricula"
                                            autoFocus
                                            ref={register({
                                                maxLength: {
                                                    value: 32,
                                                    message: translate("login.signup.validate.maxLength32")
                                                }
                                            })}
                                        />
                                        {errors.numeroPaquete && <div className="mt-1 text-xs font-medium text-destructive">{errors.numeroPaquete.message}</div>}
                                    </div>
                                </div>
                                
                                    <div className="mb-3 text-left w-full md:w-6/12 mb-2">
                                    <div className="flex w-full items-stretch">
                                        <div className="flex items-center">
                                             <span className="flex items-center px-3 text-muted-foreground" id="senha">
                                                <MdIcons.MdPassword size={14} />
                                            </span>
                                        </div>
                                            <input
                                            type="password"
                                            className={"h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed h-9 text-sm text-sm" + (errors.numeroTracking ? " border-destructive" : "")}
                                            placeholder={translate("global.senha")}
                                            id="senha"
                                            name="senha"
                                            ref={register({
                                                maxLength: {
                                                value: 32,
                                                message: translate("login.signup.validate.maxLength32")
                                                                }
                                                })} />
                                                {errors.numeroTracking && <div className="mt-1 text-xs font-medium text-destructive">{errors.numeroTracking.message}</div>}
                                            </div>
                                        </div>          
                            </div>
                            <div className="flex flex-wrap -mx-2">
                                <div className="mb-3 w-full text-center mb-0">
                                    <button
                                        className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 border border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-secondary-foreground mx-2 mt-2"
                                        type="reset"
                                        onClick={handleResetForm}
                                    >
                                        {translate("global.clean")}
                                    </button>
                                    <button
                                        className={`inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90 mx-2 mt-2`}
                                        type="submit"
                                        style={{ width: '120px' }}
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <Spinner type={1} size={14} role="status" aria-hidden="true" />
                                                <span className="sr-only">{translate("sidebar.options.platforms.GenerateQR")}</span>
                                            </>
                                        ) : (
                                            <span>
                                                {translate("sidebar.options.platforms.GenerateQR")}
                                            </span>
                                        )}
                                    </button>
                                </div>
                           </div>
                        </div>
                          

                        </>
                    )
                )}
              
              </form>
          </div>
         
          <ModalContent
                title={modalTitle}
                body={body}
                footer={footer}
                isOpenModal={isOpenModal}
                onHide={() => setIsOpenModal(false)}
            />
          </>
    );
}

export default FormGenerate;